import { useEffect } from "react";

// Vercel Web Analytics — mesure d'audience sans cookie ni bannière.
//
// POURQUOI PAS LE PAQUET @vercel/analytics :
// il déclare des peers optionnels pour SvelteKit, Nuxt, Remix... et npm tente
// de les résoudre. Sur ce projet, la branche SvelteKit tire TypeScript 5.9 qui
// entre en conflit avec le TypeScript 4.9 de react-scripts. L'installer en
// --legacy-peer-deps retire typescript du lockfile et `npm ci` échoue ensuite
// avec EUSAGE — or c'est exactement la commande que Vercel lance au build.
// Vérifié le 17/09/2026 : le déploiement aurait cassé.
//
// Le composant officiel ne fait qu'une chose, et c'est reproduit ici à
// l'identique : poser dans <head> un <script defer> vers le script maison de
// Vercel, avec les attributs data-sdkn / data-sdkv qui l'identifient. Tout le
// reste — pages vues, changements de route d'une SPA — est géré par ce script,
// qui suit automatiquement sauf si on pose data-disable-auto-track.
// Même logique que la limite de débit Upstash : appel direct, zéro dépendance.
//
// VIE PRIVÉE : aucun cookie, aucun identifiant persistant, aucun localStorage.
// Le script est servi par notre propre domaine, donc aucune requête vers un
// tiers. Rien à faire consentir, donc pas de bannière à ajouter.
//
// ⚠️ PRÉREQUIS : Web Analytics doit être activé dans les réglages du projet
// Vercel. Sans ça /_vercel/insights/script.js n'existe pas, le chargement
// échoue et aucune donnée n'est collectée.

const SCRIPT_SRC = "/_vercel/insights/script.js";

export default function Analytics() {
  useEffect(() => {
    // En local le script n'est pas servi : on n'injecte rien plutôt que de
    // laisser une erreur 404 dans la console à chaque `npm start`.
    if (process.env.NODE_ENV !== "production") return;
    if (document.head.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;

    const script = document.createElement("script");
    script.src = SCRIPT_SRC;
    script.defer = true;
    script.dataset.sdkn = "@vercel/analytics";
    script.dataset.sdkv = "2.0.1";
    script.onerror = () => {
      // Bloqueur de pub, ou Web Analytics pas encore activé côté Vercel.
      // Dans les deux cas c'est sans conséquence pour le visiteur.
    };
    document.head.appendChild(script);
  }, []);

  return null;
}
